export function updateAllUsers(state, { users }) {
  state.all = users;
}

export function updateCurrentUser(state, { user }) {
  state.current = user;
}

export function flush(state) {
  state.current = null;
  state.all = [];
}
